import { FaClock ,FaCheckCircle} from "react-icons/fa"; 

const ExamLevelCard = ({
  title,
  level,
  duration,
  questions,
  passPercentage,
  topics = [],
  rating,
  certifiedCount,
   isSelected,
}) => {
  return (
      <div
      className={`rounded-lg border shadow-sm p-4 h-100 position-relative hover-card ${
        isSelected ? "border-success" : "border-primary"
      }`}
      style={{ cursor: "pointer" }}
    >
        {/* Tick if selected */}
      {isSelected && (
        <FaCheckCircle
          className="text-success position-absolute"
          style={{ top: "10px", right: "10px", fontSize: "1.5rem" }}
        />
      )}
        <div className="p-4">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold text-light mb-0">{title}</h5>
            <span className="badge bg-success">{level}</span>
          </div>

          {/* Info Row */}
          <div className="row mx-0 mb-3">
            <div className="col px-1">
              <small className="text-muted-custom d-flex align-items-center">
                <FaClock size={12} className="me-1" />
                {duration}
              </small>
            </div>
            <div className="col px-1">
              <small className="text-muted-custom">{questions} questions</small>
            </div>
            <div className="col px-1">
              <small className="text-muted-custom">{passPercentage}% pass</small>
            </div>
          </div>

          {/* Topics */}
          <div className="mb-3">
            <h6 className="text-light mb-2">Topics Covered:</h6>
            <div className="d-flex flex-wrap gap-1">
              {topics.map((topic, idx) => (
                <span key={idx} className="badge bg-primary small">
                  {topic}
                </span>
              ))}
            </div>
          </div>

          {/* Footer Stats */}
          <div className="row mx-0 text-center">
            <div className="col px-1">
              <h6 className="text-primary-custom fw-bold">{rating}★</h6>
              <small className="text-muted">Rating</small>
            </div>
            <div className="col px-1">
              <h6 className="text-primary-custom fw-bold">{certifiedCount}</h6>
              <small className="text-muted">Certified</small>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ExamLevelCard;